import React, { lazy } from 'react';
import IconCompliance from '@/assets/images/menu/icon-compliance.react.svg?react';
import { MultiApp } from '@/config/context';
import { isAndroid, isHarmonyOS, isIOS, isVisionOS } from '@/infrastructure/product-info';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const complianceRoutes = (): IRouteConfig[] => [
  {
    path: '/compliance',
    name: 'Rightly合规',
    icon: <MenuIcon icon={IconCompliance}  fontSize={16} />,
    hideInMenu: !isAndroid() && !isIOS() && !isHarmonyOS() && !isVisionOS(),
    disabled: !isAndroid() && !isIOS() && !isHarmonyOS() && !isVisionOS(),
    versions: [MultiApp.WOA, MultiApp.Internal],
    routes: [
      {
        path: '/compliance/index',
        name: '指标与报告',
        flag: 'subMenu',
        routes: [
          {
            path: '/compliance/analytics',
            name: '指标分析',
            component: lazy(() => import('@/presentation/pages/compliance/analytics')),
          },
          {
            path: '/compliance/report',
            name: '合规报告',
            component: lazy(() => import('@/presentation/pages/compliance/report')),
            hideInMenu: !isAndroid() && !isIOS(),
          },
          {
            path: '/compliance/agreement',
            name: '用户同意管理',
            component: lazy(() => import('@/presentation/pages/compliance/agreement')),
            hideInMenu: !isAndroid() && !isIOS(),
          },
          {
            path: '/compliance/privacy-flare',
            name: '隐私照明弹',
            component: lazy(() => import('@/presentation/pages/compliance/privacy-flare')),
            hideInMenu: !isAndroid(),
          },
        ],
      },
      {
        path: '/compliance/invoke',
        name: '调用合规',
        flag: 'subMenu',
        routes: [
          {
            path: '/compliance/issues/list',
            name: '隐私API调用',
            component: lazy(() => import('@/presentation/pages/compliance/issues/list')),
          },
          {
            path: '/compliance/issues/detail',
            name: '隐私API调用详情',
            component: lazy(() => import('@/presentation/pages/compliance/issues/detail')),
            hideInMenu: true,
          },
          {
            path: '/compliance/modules/list',
            name: '分场景管控',
            component: lazy(() => import('@/presentation/pages/compliance/modules/list')),
            hideInMenu: !isAndroid() && !isIOS(),
          },
          {
            path: '/compliance/modules/detail',
            name: '分场景管控详情',
            component: lazy(() => import('@/presentation/pages/compliance/modules/detail')),
            hideInMenu: true,
          },
        ],
      },
      {
        path: '/compliance/specific',
        name: '专项合规',
        flag: 'subMenu',
        hideInMenu: !isAndroid() && !isIOS(),
        routes: [
          {
            path: '/compliance/self-launch/list',
            name: '自启动&关联启动',
            component: lazy(() => import('@/presentation/pages/compliance/self-launch/list')),
            hideInMenu: !isAndroid(),
          },
          {
            path: '/compliance/self-launch/detail',
            name: '自启动&关联启动详情',
            component: lazy(() => import('@/presentation/pages/compliance/self-launch/detail')),
            hideInMenu: true,
          },
          {
            path: '/compliance/network/list',
            name: '网络传输敏感字段',
            component: lazy(() => import('@/presentation/pages/compliance/network/list')),
            hideInMenu: !isAndroid() && !isIOS(),
          },
          {
            path: '/compliance/network/detail',
            name: '网络传输敏感字段详情',
            component: lazy(() => import('@/presentation/pages/compliance/network/detail')),
            hideInMenu: true,
          },
          {
            path: '/compliance/file-access/list',
            name: '文件访问监控',
            component: lazy(() => import('@/presentation/pages/compliance/file-access/list')),
            hideInMenu: !isAndroid(),
          },
          {
            path: '/compliance/file-access/detail',
            name: '文件访问监控详情',
            component: lazy(() => import('@/presentation/pages/compliance/file-access/detail')),
            hideInMenu: true,
          },
          {
            path: '/compliance/download/list',
            name: '下载六要素',
            component: lazy(() => import('@/presentation/pages/compliance/download/list')),
            hideInMenu: !isAndroid(),
          },
          {
            path: '/compliance/download/detail',
            name: '下载六要素详情',
            component: lazy(() => import('@/presentation/pages/compliance/download/detail')),
            hideInMenu: true,
          },
        ],
      },
      {
        path: '/compliance/config/list',
        name: '配置列表',
        component: lazy(() => import('@/presentation/pages/compliance/config/list')),
        hideInMenu: true,
      },
    ],
  },
];

export default complianceRoutes;
